import {
  SMALL_WRITING_GIF_HEIGHT,
  SMALL_WRITING_GIF_WIDTH,
} from '@chegg-wt/core-wa/constants/paraphraser'
import dynamic from 'next/dynamic'
import { colors } from '@chegg-ui/theme'
import { AIStarIcon } from '../icons/AIStarIcon'
import { BetaReleaseContainer, BetaReleaseText } from '../EntryPointBanner/styled'
import {
  ModalScreenContainer,
  ModalScreenHeading,
  ModalScreenAnimation,
  ModalScreenContent,
  ModalScreenSubheading,
  MarginLeft,
} from './styled'

const ImproveWritingAnimation = dynamic(
  () => import('../CardsContainer/EmptySuggestionsCard/ImproveWritingAnimation')
)

const SmallScreenModalBlocker = () => {
  return (
    <ModalScreenContainer>
      <BetaReleaseContainer>
        <BetaReleaseText>
          <span>New!</span>
          <MarginLeft>
            <AIStarIcon color={colors.violet700} size="x-small" />
          </MarginLeft>
        </BetaReleaseText>
      </BetaReleaseContainer>
      <ModalScreenHeading>
        Helping you get from written to <span>well written</span>
      </ModalScreenHeading>
      <ModalScreenSubheading>
        Please use a larger screen size to start enjoying these features.*
      </ModalScreenSubheading>
      <ModalScreenAnimation>
        <ImproveWritingAnimation
          width={SMALL_WRITING_GIF_WIDTH}
          height={SMALL_WRITING_GIF_HEIGHT}
        />
      </ModalScreenAnimation>
      <ModalScreenContent>*Mobile supported version is coming soon!</ModalScreenContent>
    </ModalScreenContainer>
  )
}

export default SmallScreenModalBlocker
